module.exports = __webpack_public_path__ + "static/img/MITCH-MARSH.b50fe7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCH-MARSH.jpg
// module id = rpPC
// module chunks = 0